import React from 'react';
import styled from 'styled-components/macro';
import {
  focusRing,
  fontSize,
  layout,
  lineHeight,
  neutral,
  radius,
  space,
} from '../../../theme/tokens';
import { SaveChangesButton } from '../../common/elements/Form';
import { StaffSubHeader } from '../../common/elements/Staff';

export const AssessmentContainer = styled.section`
  margin: ${space[3]} 0;
`;

const Title = styled(StaffSubHeader).attrs({ as: 'input' })`
  width: 100%;
  min-width: 0;
  min-height: ${layout.touchTarget};
  padding: ${space[2]} ${space[3]};
  border: 1px solid ${neutral.borderStrong};
  border-radius: ${radius.md};
  background: ${neutral.surface};
  font-family: inherit;
  &:disabled {
    border-color: transparent;
    background-color: ${({ theme }) => theme.appBackground};
  }
  ${focusRing}
`;

export const AssessmentTitle = ({ form, field, ...props }) => {
  return <Title {...field} {...props} />;
};

export const InfoText = styled.p`
  grid-area: text;
  margin: 0;
  font-size: ${fontSize.md};
  line-height: ${lineHeight.normal};
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.textDark};
`;

export const PublishButton = styled(SaveChangesButton)`
  margin-top: ${space[3]};
`;

export * from '../../common/elements/Assessments';
export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
